// extracted by mini-css-extract-plugin
export default {"actions":"COFmy__actions","entryIcon":"S_7bt__entryIcon","entryNameContainer":"OYf0P__entryNameContainer","entryName":"RJdVd__entryName"};